export default "__VITE_ASSET__BthPa_CN__"